(function() {
  'use strict';

  var STORAGE_KEY = 'soomom_saved_items';

  function getSaved() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
    } catch (e) {
      return [];
    }
  }

  function setSaved(items) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    dispatchUpdate();
  }

  function addSaved(variantId, productHandle) {
    var saved = getSaved();
    var exists = saved.some(function(item) { return item.variantId === variantId; });
    if (!exists) {
      saved.push({ variantId: variantId, productHandle: productHandle, addedAt: Date.now() });
      setSaved(saved);
    }
  }

  function removeSaved(variantId) {
    var saved = getSaved().filter(function(item) { return item.variantId !== variantId; });
    setSaved(saved);
  }

  function dispatchUpdate() {
    document.dispatchEvent(new CustomEvent('soomom:saved-items-updated', {
      detail: { items: getSaved() }
    }));
  }

  function isSaved(variantId) {
    return getSaved().some(function(item) { return item.variantId === variantId; });
  }

  function bookmark(btn) {
    if (!btn) return false;

    var variantId = parseInt(btn.getAttribute('data-variant-id'), 10);
    var productHandle = btn.getAttribute('data-product-handle');
    if (!variantId || !productHandle) return false;

    if (isSaved(variantId)) {
      removeSaved(variantId);
      btn.setAttribute('data-saved', 'false');
    } else {
      addSaved(variantId, productHandle);
      btn.setAttribute('data-saved', 'true');
    }

    return false;
  }

  function syncBookmarkStates() {
    var buttons = document.querySelectorAll('.cart-item__save');
    for (var i = 0; i < buttons.length; i++) {
      var b = buttons[i];
      var vid = parseInt(b.getAttribute('data-variant-id'), 10);
      b.setAttribute('data-saved', isSaved(vid) ? 'true' : 'false');
    }
  }

  window.SoomomSaved = {
    getSaved: getSaved,
    addSaved: addSaved,
    removeSaved: removeSaved,
    isSaved: isSaved,
    bookmark: bookmark,
    syncBookmarkStates: syncBookmarkStates
  };

  // Sync on initial load + whenever cart drawer re-renders
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncBookmarkStates);
  } else {
    syncBookmarkStates();
  }

  // Observe cart drawer for re-render → re-apply saved state
  var cartDrawerEl = document.querySelector('cart-drawer');
  if (cartDrawerEl) {
    new MutationObserver(syncBookmarkStates).observe(cartDrawerEl, { childList: true, subtree: true });
  } else {
    // try again after DOM ready
    document.addEventListener('DOMContentLoaded', function() {
      var el = document.querySelector('cart-drawer');
      if (el) new MutationObserver(syncBookmarkStates).observe(el, { childList: true, subtree: true });
    });
  }

  // ─── Saved items page: render list ───────────────────────────────
  function renderSavedItemsPage() {
    var listEl = document.getElementById('saved-items-list');
    if (!listEl) return;

    var emptyEl = document.getElementById('saved-items-empty');
    var saved = getSaved();

    if (saved.length === 0) {
      listEl.innerHTML = '';
      if (emptyEl) emptyEl.style.display = 'block';
      return;
    }
    if (emptyEl) emptyEl.style.display = 'none';

    listEl.innerHTML = '<div class="saved-items__loading">Loading…</div>';

    Promise.all(saved.map(function(s) {
      return fetch('/products/' + s.productHandle + '.js')
        .then(function(r) { return r.ok ? r.json() : null; })
        .then(function(product) {
          if (!product) return null;
          var variant = product.variants.find(function(v) { return v.id === s.variantId; });
          if (!variant) return null;
          return { product: product, variant: variant, savedAt: s.addedAt };
        })
        .catch(function() { return null; });
    })).then(function(results) {
      var valid = results.filter(Boolean);
      if (valid.length === 0) {
        listEl.innerHTML = '';
        if (emptyEl) emptyEl.style.display = 'block';
        return;
      }
      listEl.innerHTML = valid.map(renderItem).join('');
    });
  }

  function renderItem(data) {
    var p = data.product;
    var v = data.variant;
    var img = v.featured_image && v.featured_image.src
      ? v.featured_image.src
      : (p.featured_image || '');
    var price = formatMoney(v.price);
    var available = v.available;

    var optionsHtml = '';
    if (v.options && v.options.length && p.options) {
      optionsHtml = p.options.map(function(name, i) {
        return '<span class="saved-item__option"><strong>' + escapeHtml(name) + ':</strong> ' + escapeHtml(v.options[i] || '') + '</span>';
      }).join('');
    }

    return ''
      + '<article class="saved-item" data-variant-id="' + v.id + '">'
      +   '<a class="saved-item__media" href="' + p.url + '">'
      +     (img ? '<img src="' + img + '" alt="' + escapeHtml(p.title) + '" loading="lazy">' : '')
      +   '</a>'
      +   '<div class="saved-item__details">'
      +     '<div class="saved-item__top">'
      +       '<a class="saved-item__name" href="' + p.url + '">' + escapeHtml(p.title) + '</a>'
      +       '<span class="saved-item__price">' + price + '</span>'
      +     '</div>'
      +     '<div class="saved-item__options">' + optionsHtml + '</div>'
      +     '<div class="saved-item__actions">'
      +       (available
            ? '<button type="button" class="saved-item__move" data-variant-id="' + v.id + '">Move to cart</button>'
            : '<button type="button" class="saved-item__move" disabled>Sold out</button>')
      +       '<button type="button" class="saved-item__remove" data-variant-id="' + v.id + '" aria-label="Remove">'
      +         '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"><path d="M3 6h18"/><path d="M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/><path d="M19 6 17.5 20a2 2 0 0 1-2 1.8h-7a2 2 0 0 1-2-1.8L5 6"/><path d="M10 11v6"/><path d="M14 11v6"/></svg>'
      +       '</button>'
      +     '</div>'
      +   '</div>'
      + '</article>';
  }

  function formatMoney(cents) {
    // Shopify variant.price is in cents. Format to $X.XX (locale-agnostic, refine if needed)
    var n = (cents / 100);
    return (window.Shopify && Shopify.formatMoney)
      ? Shopify.formatMoney(cents, (window.theme && theme.moneyFormat) || '${{amount}}')
      : '$' + n.toFixed(2);
  }

  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function(c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  // ─── Saved items page: actions ───────────────────────────────────
  document.addEventListener('click', function(e) {
    if (!e.target.closest) return;
    var removeBtn = e.target.closest('.saved-item__remove');
    if (removeBtn) {
      e.preventDefault();
      var id = parseInt(removeBtn.getAttribute('data-variant-id'), 10);
      removeSaved(id);
      return;
    }
    var moveBtn = e.target.closest('.saved-item__move');
    if (moveBtn && !moveBtn.disabled) {
      e.preventDefault();
      if (moveBtn.classList.contains('is-loading')) return;
      moveBtn.classList.add('is-loading');
      moveBtn.textContent = 'Adding…';

      var id = parseInt(moveBtn.getAttribute('data-variant-id'), 10);
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
      })
      .then(function(r) { return r.json(); })
      .then(function(res) {
        if (res && res.status) {
          moveBtn.classList.remove('is-loading');
          moveBtn.textContent = 'Failed';
          setTimeout(function() { moveBtn.textContent = 'Move to cart'; }, 1500);
          return;
        }
        removeSaved(id);
      })
      .catch(function() {
        moveBtn.classList.remove('is-loading');
        moveBtn.textContent = 'Move to cart';
      });
    }
  });

  document.addEventListener('soomom:saved-items-updated', renderSavedItemsPage);
  document.addEventListener('DOMContentLoaded', renderSavedItemsPage);
})();
